<template>
  <div class="guide-card">
    <div class="d-flex align-items-center gap-2">
      <i class="guide-card__icon icon-outline_book"></i>
      <span class="guide-card__title">{{ $t('global.importData.guide') }}</span>
    </div>

    <hr />

    <div class="guide-card__list">
      <ol>
        <li>
          <p class="title">{{ $t('global.importData.downloadTemplate') }}</p>
          <p class="description">{{ $t('global.importData.downloadDesc') }}</p>
          <McButton
            :text="$t('global.importData.downloadTemplate')"
            icon="icon-outline_download"
            size="sm"
            @click="handleDownloadTemplate"
          />
        </li>
        <li>
          <p class="title">{{ $t('global.importData.copyData') }}</p>
          <p class="description" v-html="$t('global.importData.copyDesc')" />
        </li>
        <li>
          <p class="title">{{ $t('global.importData.upload') }}</p>
          <p class="description" v-html="$t('global.importData.uploadDesc3')" />
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  methods: {
    handleDownloadTemplate() {
      window.open(`${process.env.VUE_APP_API_ORDER_URL}/product/import/template`, '_self')
    },
  },
}
</script>

<style lang="scss" scoped>
.guide-card {
  padding: 20px;
  padding-top: 15px;
  border-radius: 4px;
  background-color: $mep-secondary-100;
  width: 100%;
  height: fit-content;
  line-height: 20px;

  ol {
    margin: 0;
    padding: 0 20px;

    li {
      color: $mep-color-text;
      margin-top: 15px;
    }

    p {
      margin: 1px 0;
      color: $mep-color-text;
    }
  }

  &__icon:before {
    font-size: 24px;
    color: $mep-color-text-400;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: $mep-color-text;
  }

  &__list {
    .title {
      font-weight: 600;
    }

    .description {
      color: $mep-color-text-300;

      :deep(strong) {
        font-weight: 600;
      }
    }
  }
}
</style>
